import { Text } from "@/components/ui/baseUi/text"
import { BoxShopEmptyView } from "@/modules/boxShop/components/boxShopEmptyView"
import { BoxShopLayout } from "@/modules/boxShop/components/boxShopLayout"
import { useBoxShopItemsCount } from "@/modules/boxShop/hooks/useBoxShopItem"
import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { useCurrentBox } from "@modules/box/hooks/useBox"
import { BoxFinancesLiteView } from "@modules/finances/components/boxFinancesLiteView"
import { Activity } from "react"

export function BoxShopPage({ className, ...props }: { className?: string } & React.ComponentProps<"div">) {
  const { result: box } = useCurrentBox()
  const shopItemsCount = useBoxShopItemsCount()
  const boxHasStripeAccount = !!box?.stripeAccountId

  if (!boxHasStripeAccount) return <BoxFinancesLiteView />

  return (
    <div className={cn("flex h-full w-full flex-col gap-6 p-6", className)} {...props}>
      {/* Header */}
      <div className="flex flex-col gap-2">
        <Text fontStyle="HL">{word("boxShop.page.header.title")}</Text>
        <Text fontStyle="BM">{word("boxShop.page.header.subtitle")}</Text>
      </div>

      <Activity mode={shopItemsCount > 0 ? "hidden" : "visible"}>
        <BoxShopEmptyView />
      </Activity>

      <Activity mode={shopItemsCount > 0 ? "visible" : "hidden"}>
        <BoxShopLayout />
      </Activity>
    </div>
  )
}
